import { render, staticRenderFns } from "./AddressFields.vue?vue&type=template&id=366e66ee&lang=pug"
import script from "./AddressFields.vue?vue&type=script&lang=js"
export * from "./AddressFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AddressSearch: require('/home/docker/code/frontend/components/AddressSearch.vue').default})
